import { Record } from 'immutable';

const RatePlanCodeValidationRequestRecord = Record({
  eventId: null,
  chain: null,
  brand: null,
  propertyId: null,
  ratePlanCodes: null,
  startDate: null,
  endDate: null
});

export class RatePlanCodeValidationRequest extends RatePlanCodeValidationRequestRecord {
  eventId: number;
  chain: string;
  brand: string;
  propertyId: string;
  ratePlanCodes: string[];
  startDate: string;
  endDate: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/rate-plan-code-validation-request.ts